import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

const CalendarService = {
  getCalendarEvents: async (token, params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await fetch(`${baseUrl}calendar?${queryString}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch calendar events');
      }

      return data.data;
    } catch (error) {
      console.error('Error fetching calendar events:', error);
      throw error;
    }
  },

  getBookingById: async (token, bookingId) => {
    try {
      const response = await fetch(`${baseUrl}users/bookings/all/${bookingId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch booking');
      }

      return data.data;
    } catch (error) {
      console.error('Error fetching booking:', error);
      throw error;
    }
  }
};

export default CalendarService;